<template>
  <div class="app">
    <router-view />
  </div>
</template>

<script>
/* eslint-disable */
import jsMain from "@/assets/js/main";

export default {
  name: "App",
  // metaInfo: {
  //   changed(metaInfo) {
  //     analytics.setCurrentScreen(metaInfo.title);
  //     analytics.logEvent("page_view");
  //     analytics.logEvent("screen_view", {
  //       app_name: name,
  //       screen_name: metaInfo.title,
  //       version: version,
  //     });
  //   },
  // },
  created() {
    const el = document.querySelector("html");
    const mql = window.matchMedia("(prefers-color-scheme: dark)");

    if (mql.matches) el.classList.replace("theme-light", "theme-dark");

    mql.onchange = (e) => {
      if (e.matches) el.classList.replace("theme-light", "theme-dark");
      else el.classList.replace("theme-dark", "theme-light");
    };
  },
};
</script>

<style lang="scss" scoped>
.calls {
  position: fixed;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  padding: 0 8px;

  .fab {
    position: static;
    display: grid;
    place-items: center;

    &:first-child {
      margin-bottom: 1rem;
    }
  }
}
</style>

<style lang="scss">
body {
  width: 100% !important;
  height: auto !important;
  background-color: #f3e8dc !important;
  // background-color: transparentize($primary-color, 0.9) !important;
}

.app {
  // height: 120%;
  // padding-bottom: 50px;

  .backdrop {
    height: 100%;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    position: absolute;

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      opacity: 0.67;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .row {
    background-color: transparent !important;
  }
}

.theme-dark {
  body {
    background-color: #171717 !important;
    color: transparentize($text-color-dark, 0.2) !important;
  }

  .card {
    box-shadow: 0 3px 6px #ffffff10 !important;
  }
}
</style>
